<template>
  <div class="profession-server">
    <div class="header">
      <div class="left" style="cursor: pointer" @click="isName = 'Home'">
        <img :src="require('assets/images/wqzk.png')" alt="" />
      </div>
      <div class="center">
        <div class="top">
          <div class="search">
            <input
              type="text"
              placeholder="专业服务"
              v-model="keyWords"
              class="input"
            />
            <div class="search-btn" @click="searchClick">搜索</div>
          </div>
          <div class="publish-task" @click="publishTask">发布任务</div>
        </div>
        <!-- <div class="bottom">
          <div
            class="search-tips"
            v-for="item in searchTipList"
            :key="item.type"
          >
            {{ item.title }}
          </div>
        </div> -->
      </div>
      <div class="right">
        <div class="my-practice" @click="isName = 'Practice'">我的执业</div>
        <div class="my-task" @click="isName = 'myQuest'">我的任务</div>
        <div class="userAvatar" @click="getuserInfo">
          <img
            :src="user.headImg || require('@/assets/images/user.png')"
            alt=""
          />
          {{ user.nickName || '个人中心' }}
        </div>
      </div>
    </div>
    <div class="nav-background">
      <div class="nav">
        <div
          class="nav-item"
          :class="{ active: currentNavId === item.id }"
          :key="item.id"
          v-for="item in practiceTypeList"
          @click="navClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="condition" v-show="isName == 'Home' && ishomeshow">
      <div class="condition-item">
        <div class="title">售价 :</div>
        <div class="value">
          <div
            class="value-item"
            :class="{ active: sort_xz === '' }"
            @click="clickSort(1, '')"
          >
            不限
          </div>
          <div
            class="value-item"
            :class="{ active: sort_xz === item.id }"
            v-for="(item, i) in priceList"
            :key="i"
            @click="clickSort(1, item)"
          >
            {{ item.pus }} <span v-if="!item.pop">元以下</span>
            <span v-if="item.pop"
              ><span v-if="item.pus">-</span>{{ item.pop }}元<span
                v-if="!item.pus"
                >以上</span
              >
            </span>
          </div>
          <div class="value-item">
            <div class="qujian">
              <input
                type="text"
                placeholder="最低价格"
                @change="inputchange(1)"
                v-model="lowestPrice"
              />
              -
              <input
                type="text"
                @change="inputchange(2)"
                placeholder="最高价格"
                v-model="highestPrice"
              />元
            </div>
          </div>
        </div>
      </div>
      <div class="condition-item">
        <div class="title">地区 :</div>
        <div class="value">
          <div
            class="value-item"
            :class="{ active: citys === '' }"
            @click="clickSort(2, '')"
          >
            不限
          </div>
          <div class="citys_item">
            <div
              class="value-item"
              :class="{ active: citys === item }"
              v-for="(item, i) in city.economizeSet"
              :key="i"
              @click="clickSort(2, item)"
            >
              <span> {{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="condition-item">
        <div class="title">任务周期 :</div>
        <div class="value">
          <div
            class="value-item"
            :class="{ active: dates === '' }"
            @click="clickSort(3, '')"
          >
            不限
          </div>
          <div
            class="value-item"
            :class="{ active: dates === item.id }"
            v-for="(item, i) in dateList"
            :key="i"
            @click="clickSort(3, item)"
          >
            {{ item.pus }} <span v-if="!item.pop">天以下</span>
            <span v-if="item.pop"
              ><span v-if="item.pus">-</span>{{ item.pop }}天<span
                v-if="!item.pus"
                >以上</span
              >
            </span>
          </div>
          <div class="value-item">
            <div class="qujian">
              <input
                type="text"
                @change="inputchanges(1)"
                v-model="cycleStartTime"
                placeholder="天数"
              />
              -
              <input
                placeholder="天数"
                v-model="cycleEndTime"
                @change="inputchanges(2)"
                type="text"
              />天
            </div>
          </div>
        </div>
      </div>
      <div class="condition-item">
        <div class="title">发布时间 :</div>

        <div class="value">
          <div
            class="value-item"
            :class="{ active: times === '' }"
            @click="clickSort(4, '')"
          >
            不限
          </div>
          <div class="value-item">
            <el-date-picker
              v-model="timevalue1"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="pickerClick"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
    </div>

    <!-- 动态组件 -->
    <component
      :userData="user"
      :taskList="taskList"
      :practiceLists="practiceList"
      :is="isName"
      :total="total"
      @updateTask="updateTask"
      ref="component"
    ></component>
    <!-- 底部盒子 -->
    <bottomBos />
    <!-- 接单弹框 -->
    <el-dialog
      :visible.sync="taskInfoDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      class="taskInfo-dialog"
    >
      <div class="tips">
        您暂不具备<span class="name"> 法务人员 </span>执业类型接单资格
        <span
          class="apply"
          @click="
            taskInfoDialogVisible = false
            applyshow = true
          "
          >点击申请</span
        >
      </div>
      <el-descriptions border title="任务信息">
        <el-descriptions-item label="执业类型">{{
          taskInfo.practiceName
        }}</el-descriptions-item>
        <el-descriptions-item label="执业地点" :span="12">{{
          taskInfo.practiceAddres
        }}</el-descriptions-item>
        <el-descriptions-item label="任务名称" :span="12">{{
          taskInfo.taskName
        }}</el-descriptions-item>
        <el-descriptions-item label="任务要求" :span="12">
          {{ taskInfo.taskRequire }}
        </el-descriptions-item>
        <el-descriptions-item label="相关资料" :span="12">
          <div v-for="(item, index) in taskInfo.taskFiles" :key="index">
            <a :href="item.filePath" :download="item.fileName">{{
              item.fileName
            }}</a>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="时限"
          >{{ taskInfo.taskHour
          }}{{
            taskInfo.taskHourType === 1
              ? '小时'
              : taskInfo.taskHourType === 2
              ? '天'
              : '年'
          }}</el-descriptions-item
        >
        <el-descriptions-item label="价格">
          <span style="color: #ff0000"
            ><span style="font-size: 12px">¥</span
            >{{ taskInfo.taskPrice }}</span
          >
          <span style="margin-left: 30px"
            >质保金 <span style="color: #409eef">5%</span></span
          >
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 申请执业弹框 -->
    <el-dialog
      :visible.sync="applyshow"
      width="600px"
      :close-on-click-modal="false"
      class="apply_dialog"
    >
      <el-descriptions border title="申请执业">
        <el-descriptions-item label="执业类型">{{
          taskInfo.practiceName
        }}</el-descriptions-item>
        <el-descriptions-item label="执业地点" :span="12">{{
          taskInfo.practiceAddres
        }}</el-descriptions-item>
        <el-descriptions-item label="任务名称" :span="12">{{
          taskInfo.taskName
        }}</el-descriptions-item>
        <el-descriptions-item label="任务要求" :span="12">
          {{ taskInfo.taskRequire }}
        </el-descriptions-item>
        <el-descriptions-item label="相关资料" :span="12">
          <div v-for="(item, index) in taskInfo.taskFiles" :key="index">
            <a :href="item.filePath" :download="item.fileName">{{
              item.fileName
            }}</a>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="时限"
          >{{ taskInfo.taskHour
          }}{{
            taskInfo.taskHourType === 1
              ? '小时'
              : taskInfo.taskHourType === 2
              ? '天'
              : '年'
          }}</el-descriptions-item
        >
        <el-descriptions-item label="价格">
          <span style="color: #ff0000"
            ><span style="font-size: 12px">¥</span
            >{{ taskInfo.taskPrice }}</span
          >
          <span style="margin-left: 30px"
            >质保金 <span style="color: #409eef">5%</span></span
          >
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <el-dialog
      title="发布任务"
      top="7vh"
      class="pulishDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item label="职业类型" prop="practiceId">
          <el-select v-model="ruleForm.practiceId" placeholder="请选择职业类型">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in practiceTypeOption"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执业地点选择" prop="addres">
          <el-cascader :options="options" v-model="ruleForm.addres">
          </el-cascader>
        </el-form-item>
        <el-form-item label="任务名称" prop="taskName">
          <el-input
            v-model="ruleForm.taskName"
            placeholder="请输入任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务要求" prop="taskRequire">
          <el-input
            type="textarea"
            v-model="ruleForm.taskRequire"
            placeholder="请输入任务要求"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传任务资料">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="/crewordapi/common/ossUpload"
            :headers="{
              Authorization: token,
            }"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :file-list="fileList"
            :on-success="fileSuccess"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="时限" prop="taskHour">
          <el-input-number
            v-model="ruleForm.taskHour"
            :min="1"
            label="时限"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="时限类型" prop="taskHourType">
          <el-select
            v-model="ruleForm.taskHourType"
            placeholder="请选择时限类型"
          >
            <el-option
              :label="item.value"
              :value="item.id"
              v-for="(item, index) in timeTypeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="taskPrice">
          <el-input-number
            v-model="ruleForm.taskPrice"
            :min="0.01"
            :precision="2"
            :step="1"
            label="价格"
            controls-position="right"
          ></el-input-number>
          <span style="font-size: 14px; margin-left: 15px; color: #409eef"
            >质保金5%</span
          >
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input
            v-model="ruleForm.contacts"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactInfo">
          <el-input
            v-model="ruleForm.contactInfo"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input
            v-model="ruleForm.wechat"
            placeholder="请输入微信号"
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input
            v-model="ruleForm.email"
            placeholder="请输入电子邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            type="textarea"
            v-model="ruleForm.remark"
            placeholder="请输入备注说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="xieyi" style="margin-left: 30px">
        <el-checkbox v-model="checked">请确认已阅读并接受</el-checkbox>
        <span
          style="color: #409eef; cursor: pointer"
          @click.stop="agreementClick(agreement[0].path)"
          >《{{ agreement[0].name }}》</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmClick">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 扫码支付 -->
    <el-dialog
      title="扫码支付"
      :visible.sync="payVisible"
      @close="onClose"
      class="payment"
    >
      <div class="content">
        <div class="notes">请使用微信扫码下方二维码完成支付</div>
        <div class="imgBox">
          <img :src="payimg" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  practiceType,
  taskList,
  follow,
  cancelFollow,
  practiceList,
  taskInfo,
  getAgreementList,
  ossUpload,
  publishTask,
  orderPayment,
  payOrderQuery,
  modifyTask,
  userInfo,
  taskAreaList,
} from 'api/professionServer'
import Home from './components/Home/home.vue'
import Practice from './components/Practice/Practice.vue'
import myQuest from './components/myQuest/myQuest.vue'
import bottomBos from './components/bottomBos/bottomBos.vue'
import qs from 'qs'
import { provinceAndCityData, CodeToText } from 'element-china-area-data'
import { getToken } from '@/utils/auth'
import user from './components/user/user.vue'
export default {
  created() {
    // 跳转组件
    this.$bus.$on('goApplyDetails', (msg) => {
      this.isName = msg
    })
    this.taskAreaList()
    this.$bus.$on('getuserinfo', (id) => {
      if (id == 1) {
        this.getuserInfo(true)
      } else {
        this.getuserInfo(false)
      }
    })
    const data = {
      label: '不限',
      value: '不限',
      children: [
        {
          children: undefined,
          label: '不限',
          value: '不限',
        },
      ],
    }
    provinceAndCityData.forEach((item) => {
      item.value = item.label
      item.children.forEach((obj) => {
        obj.value = obj.label
      })
      item.children.unshift({
        label: '不限',
        value: '不限',
        children: undefined,
      })
    })

    provinceAndCityData.unshift(data)

    let TokenObj = getToken()
    TokenObj = TokenObj ? JSON.parse(TokenObj) : ''
    let Token = JSON.parse(localStorage.getItem('auth_token'))
    if (TokenObj || Token) {
      this.token = TokenObj
        ? `${TokenObj.token_type} ${TokenObj.access_token}`
        : `bearer  ${Token}`
    }
    this.getAgreementList()
    this.getPracticeType()
    this.getTaskList()
    this.getPracticeList()

    if (TokenObj || Token) {
      this.getuserInfo(false)
    }
  },
  components: {
    Home,
    Practice,
    bottomBos,
    myQuest,
    user,
  },
  data() {
    return {
      cycleStartTime: '',
      cycleEndTime: '',
      timevalue1: '',
      highestPrice: '',
      lowestPrice: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      // 搜索内容
      keyWords: '',
      ishomeshow: true,
      isName: 'Home',
      applyshow: false,
      dialogVisible: false,
      options: provinceAndCityData,
      token: '',
      payVisible: false,
      payimg: '',
      ruleForm: {
        addres: [],
        practiceAddres: [],
        taskHour: 1,
        taskPrice: 0.01,
        contacts: '',
        contactInfo: '',
        wechat: '',
        email: '',
        remark: '',
        taskHourType: 0,
        taskRequire: '',
        taskName: '',
        practiceId: '',
      },
      checked: false,
      rules: {
        practiceId: [
          { required: true, message: '请选择职业类型', trigger: 'change' },
        ],
        addres: [
          { required: true, message: '请选择执业地点', trigger: 'change' },
        ],
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          {
            min: 2,
            max: 99,
            message: '长度在 2 到 99 个字符',
            trigger: 'blur',
          },
        ],
        taskRequire: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          {
            min: 1,
            max: 251,
            message: '长度在 2 到 251 个字符',
            trigger: 'blur',
          },
        ],
        taskHour: [
          { required: true, message: '请输入任务时限', trigger: 'blur' },
        ],
        taskHourType: [
          { required: true, message: '请选择时限类型', trigger: 'change' },
        ],
        taskPrice: [{ required: true, message: '请输价格', trigger: 'blur' }],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        contactInfo: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
      },
      searchTipList: [
        {
          title: '法务专员',
          type: 1,
        },
        {
          title: '法务专员',
          type: 2,
        },
        {
          title: '法务专员',
          type: 3,
        },
        {
          title: '法务专员',
          type: 4,
        },
        {
          title: '法务专员',
          type: 5,
        },

        {
          title: '法务专员',
          type: 6,
        },
      ],
      currentNavId: '',
      practiceTypeList: [],
      practiceTypeOption: [],
      currentPrice: '',

      //排序数据
      sortData: {
        time: 1,
        pase: 2,
      },
      sort_xz: '',
      citys: '',
      dates: '',
      times: '',
      dateList: [
        {
          pus: '2',
          pop: '',
          id: 0,
        },
        {
          pus: '2',
          pop: '5',
          id: 1,
        },
        {
          pus: '5',
          pop: '10',
          id: 2,
        },

        {
          pus: '',
          pop: '10',
          id: 3,
        },
      ],
      priceList: [
        {
          pus: '100',
          pop: '',
          id: 0,
        },
        {
          pus: '100',
          pop: '200',
          id: 1,
        },
        {
          pus: '200',
          pop: '300',
          id: 2,
        },
        {
          pus: '300',
          pop: '400',
          id: 3,
        },
        {
          pus: '400',
          pop: '500',
          id: 4,
        },
        {
          pus: '',
          pop: '500',
          id: 5,
        },
      ],
      total: 0,
      city: [],
      taskQuery: {
        page: 1,
        limit: 10,
        sort: '',
        sortType: '',
        keyword: '',
        highestPrice: '', //最高价格
        lowestPrice: '', //最低价格
      },
      practiceQuery: {
        page: 1,
        limit: 10,
        keyword: '',
      },
      timeTypeList: [
        {
          id: 0,
          value: '小时',
        },
        {
          id: 1,
          value: '天',
        },
        {
          id: 2,
          value: '月',
        },
        {
          id: 3,
          value: '年',
        },
      ],
      fileList: [],
      taskList: [],
      practiceList: [],
      taskInfoDialogVisible: false,
      taskInfo: {},
      timer: null,
      agreement: [{}],
      user: {},
    }
  },
  // 事件
  watch: {
    timevalue1(val) {
      if (!val) {
        this.clickSort(4, '')
      }
    },
  },
  methods: {
    // 获取地区信息
    async taskAreaList() {
      let data = await taskAreaList()
      if (data.code == 200) {
        this.city = data.data
      }
    },
    userinfo(val) {
      this.user = val
    },
    publishTask() {
      this.dialogVisible = true
    },
    onClose() {
      clearInterval(this.timer)
      this.timer = null
    },
    confirmClick() {
      if (!this.checked) {
        this.$message.error('请勾选任务发布协议')
        return
      }
      this.$refs['ruleForm'].validate((vaild) => {
        if (vaild) {
          this.ruleForm.practiceAddres = this.ruleForm.addres.join('/')
          const taskFiles = this.fileList.map((item) => {
            console.log(item)
            const flie = {
              fileName: item.name,
              filePath: item.response ? item.response.data : item.url,
            }
            return flie
          })
          this.ruleForm.taskFiles = taskFiles
          if (this.ruleForm.id) {
            this.ruleForm.taskId = this.ruleForm.id
            modifyTask(this.ruleForm).then((res) => {
              this.$message.success('修改成功')
              this.$refs['component'].getQuestList(
                this.$refs['component'].tab[0]
              )
              this.$refs['ruleForm'].resetFields()
              this.$refs['upload'].clearFiles()
              this.dialogVisible = false
            })
          } else {
            publishTask(this.ruleForm).then((res) => {
              if (res.code === 200) {
                this.orderPayment(res.data)
              } else {
                this.$message.error(res.data)
              }
            })
          }
        }
      })
    },
    // 支付
    async orderPayment(orderId) {
      const data = {
        applicationTpye: this.$store.state.publicType,
        openId: '',
        orderId: orderId,
        wayCode: 'WX_NATIVE',
      }

      const res = await orderPayment(data)

      if (res.code !== 200) return
      this.payimg = res.data.payData
      this.payVisible = true

      this.timer = setInterval(() => {
        this.payOrderQuery(res.data.payOrderId)
      }, 3000)
    },

    // 订单支付状态查询
    async payOrderQuery(id) {
      let res = await payOrderQuery({
        payOrderId: id,
      })

      if (res.code !== 200) return
      clearInterval(this.timer)

      this.timer = null
      this.payVisible = false
      if (this.isName == 'myQuest') {
        this.$refs['component'].getQuestList(this.$refs['component'].tab[0])
      } else if (this.isName == 'Home') {
        this.taskQuery.page = 1
        this.getTaskList()
      }
      this.$refs['ruleForm'].resetFields()
      this.$refs['upload'].clearFiles()
      this.dialogVisible = false

      this.$message.success('支付成功')
      this.$alert(
        '您提交的任务正在审核中,审核结果将会在1个小时内以短信的方式通知您，请耐心等候!',
        '提示',
        {
          confirmButtonText: '确定',
          callback: (action) => {},
        }
      )
    },
    customUpload(files) {
      const { file } = files
      const formData = new FormData()
      formData.append('file', file)
      ossUpload(formData).then((res) => {
        if (res.code === 200) {
          console.log(this.fileList)
        }
      })
    },
    fileSuccess(res, file, fileList) {
      console.log(fileList)
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    // 搜索
    searchClick() {
      this.taskQuery.keyword = this.keyWords
      this.practiceQuery.keyword = this.keyWords
      this.getTaskList()
      this.getPracticeList()
    },
    inputchange(id) {
      if (id == 1) {
        this.taskQuery.lowestPrice = this.lowestPrice
      } else {
        this.taskQuery.highestPrice = this.highestPrice
      }
      this.getTaskList()
    },
    inputchanges(id) {
      this.taskQuery.taskHourType = 1
      if (id == 1) {
        this.taskQuery.cycleStartTime = this.cycleStartTime
      } else {
        this.taskQuery.cycleEndTime = this.cycleEndTime
      }
      this.getTaskList()
    },
    pickerClick(v) {
      this.taskQuery.releaseStartTime = this.timevalue1[0]
      this.taskQuery.releaseEndTime = this.timevalue1[1]
      this.getTaskList()
    },
    // 排序
    clickSort(id, val) {
      // 售价
      if (val && id == 1) {
        this.sort_xz = val.id
        if (val.id == 0) {
          this.taskQuery.highestPrice = val.pus
          this.taskQuery.lowestPrice = ''
        } else if (val.id == 5) {
          this.taskQuery.highestPrice = ''
          this.taskQuery.lowestPrice = val.pop
        } else {
          this.taskQuery.highestPrice = val.pop
          this.taskQuery.lowestPrice = val.pus
        }
      } else if (id == 1) {
        this.sort_xz = ''
        this.taskQuery.lowestPrice = ''
        this.taskQuery.highestPrice = ''
      }
      // 地区
      if (val && id == 2) {
        this.citys = val
        this.taskQuery.practiceAddress = val
      } else if (id == 2) {
        this.citys = ''
        this.taskQuery.practiceAddress = ''
      }
      // 任务周期
      if (val && id == 3) {
        this.taskQuery.taskHourType = 1
        this.dates = val.id
        if (val.id == 0) {
          this.taskQuery.cycleEndTime = val.pus
          this.taskQuery.cycleStartTime = ''
        } else if (val.id == 3) {
          this.taskQuery.cycleEndTime = ''
          this.taskQuery.cycleStartTime = val.pop
        } else {
          this.taskQuery.cycleEndTime = val.pop
          this.taskQuery.cycleStartTime = val.pus
        }
      } else if (id == 3) {
        this.dates = ''
        this.taskQuery.cycleStartTime = ''
        this.taskQuery.cycleEndTime = ''
      }
      // 发布时间
      if (id == 4) {
        this.times = ''
        this.timevalue1 = []
        this.taskQuery.releaseStartTime = ''
        this.taskQuery.releaseEndTime = ''
      }

      this.getTaskList()
    },
    async getPracticeType() {
      const { data: res } = await practiceType()
      this.practiceTypeOption = { ...res }
      this.practiceTypeList = res
      this.practiceTypeList.unshift({ name: '全部', id: '' })
    },
    async getAgreementList() {
      let res = await getAgreementList()
      if (res.code !== 200) return
      this.agreement = res.data.filter((el) => {
        if (el.text == '任务发布协议') {
          el.name = el.values.split('|')[0]
          el.path = el.values.split('|')[1]
          return el
        }
      })
    },
    agreementClick(url) {
      window.open(url)
    },
    getTaskList() {
      const params = {
        practiceTypeId: this.currentNavId,
        ...this.taskQuery,
      }
      taskList(qs.stringify(params)).then((res) => {
        if (res.code === 200) {
          // if (this.taskQuery.page === 1) {
          this.taskList = res.data.data
          this.total = res.data.total
          console.log(this.total)
          // } else {
          //   this.taskList = [...this.taskList, ...res.data.data]
          // }
        }
      })
    },

    async getuserInfo(lock = true) {
      try {
        const res = await userInfo()
        if (res.code != 200) return
        let val = res.data['mobile']
        val = val.substring(0, 3) + '***' + val.substring(7)
        this.user = res.data
        this.user.iphone = val
        console.log(res.data)
        this.$store.commit('SET_USER_INFO', {
          userInfo: res.data,
        })

        if (lock) {
          this.isName = 'user'
        }
      } catch (error) {
        console.log(error)
      }
    },
    getPracticeList() {
      const params = {
        practiceTypeId: this.currentNavId,
        ...this.practiceQuery,
      }
      practiceList(qs.stringify(params)).then((res) => {
        if (this.practiceQuery.page === 1) {
          this.practiceList = res.data.data
        } else {
          this.practiceList = [...this.practiceList, ...res.data.data]
        }
        console.log(this.practiceList)
      })
    },

    navClick(item) {
      this.taskQuery.page = 1
      this.practiceQuery.page = 1
      this.currentNavId = item.id
      this.isName = 'Home'
      this.getTaskList()
      this.getPracticeList()
    },
    async followClick(item) {
      if (item.attention) {
        item.attention = !item.attention
        const res = await cancelFollow(item.userId)
      } else {
        item.attention = !item.attention
        const res = await follow(item.userId)
      }
    },
    updateTask(item) {
      console.log(item)
      this.ruleForm = item
      this.ruleForm.addres = item.practiceAddres.split('/')
      this.fileList = item.taskFiles.map((item) => {
        return {
          name: item.fileName,
          url: item.filePath,
        }
      })
      this.checked = true
      this.dialogVisible = true
    },
    getTaskInfo(item) {
      taskInfo(item.id).then((res) => {
        this.taskInfo = res.data
        this.taskInfoDialogVisible = true
      })
    },

    // 切换组件
    onNotice(val) {
      this.isName = val
    },
  },
}
</script>

<style lang="scss" scoped>
.profession-server {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  // margin-top: 65px;
  background: #f7f8fb;
  ::v-deep .pulishDialog {
    .el-dialog {
      .el-dialog__body {
        height: 650px;
        overflow: auto;
      }
    }
  }
  // 支付弹窗
  .payment {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 500px;
      height: 390px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        height: 42px;
        background: #f4f6f7;
        padding: 0;
        line-height: 42px;
        .el-dialog__title {
          margin-left: 15px;
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: $font-size-small;
          right: $font-size-small;
          font-size: $font-size-large;
        }
      }
      .el-dialog__body {
        padding: 65px 20px;
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .notes {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-black;
          }
          .imgBox {
            width: 110px;
            height: 110px;
            margin-top: 30px;
            img {
              width: 110px;
              height: 110px;
            }
          }
        }
      }
    }
  }
  ::v-deep .taskInfo-dialog {
    .el-dialog {
      .el-dialog__header {
        padding: 0px !important;
      }
      .el-dialog__body {
        padding-top: 40px !important;
        .tips {
          background: #fdf6ec;
          color: #f9ae3d;
          border-radius: 5px;
          font-size: 15px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin-bottom: 20px;
          .name {
            text-decoration: underline;
            font-weight: bold;
          }
          .apply {
            cursor: pointer;
            color: #409eef;
            text-decoration: underline;
          }
        }
      }
    }
  }
  > .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
    padding: 34px 0 20px;
    background: #fff;
    position: relative;
    z-index: 20;
    .left {
      > img {
        width: 200px;
      }
    }
    .center {
      .top {
        display: flex;
        align-items: center;
        .search {
          display: flex;
          align-items: center;
          width: 670px;
          height: 42px;
          border: 1px solid #326afb;
          // box-shadow: 0px 0px 0px 1px #326afb;
          border-radius: 21px;
          padding-left: 15px;
          box-sizing: border-box;
          .input {
            flex: 1;
            border: none;
            outline: none;
            color: #999999;
            font-size: 16px;
          }
          .search-btn {
            width: 100px;
            height: 42px;
            background: #326afb;
            border: 1px solid #326afb;
            border-radius: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            cursor: pointer;
          }
        }
        .publish-task {
          width: 100px;
          height: 42px;
          background: #326afb;
          cursor: pointer;
          border: 1px solid #326afb;
          border-radius: 21px;
          margin-left: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }
      .bottom {
        display: flex;
        flex-wrap: wrap;
        width: 670px;
        gap: 39px;
        margin-top: 25px;
        .search-tips {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          cursor: pointer;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 13px;
      > div {
        width: 100px;
        height: 42px;
        background: #ffffff;
        border: 1px solid #326afb;
        border-radius: 21px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #326afb;
      }

      .userAvatar {
        border: 0;
        height: 46px;
        width: 150px;
        font-size: 14px;
        overflow: hidden;
        cursor: pointer;

        img {
          width: 46px;
          height: 46px;
          margin-right: 10px;
          border-radius: 50%;
        }
      }
    }
  }
  .nav-background {
    width: 100%;
    height: 46px;
    background: #326afb;
    .nav {
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
      margin: 0 auto;
      height: 100%;
      max-width: 1430px;
      .nav-item {
        height: 100%;
        // width: 86px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background: #0047ff;
        }
      }
      .active {
        background: #0047ff;
      }
    }
  }
  .condition {
    width: 1130px;
    // height: 107px;
    background: #ffffff;
    border-radius: 10px;
    margin: 20px auto;
    padding: 15px 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .condition-item {
      display: flex;
      gap: 20px;
      align-items: center;
      .title {
        width: 80px;
        text-align: right;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
      .value {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 20px;
        .citys_item {
          width: calc(100% - 150px);
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }
        .value-item {
          font-size: 13px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          cursor: pointer;

          .qujian {
            input {
              width: 100px;
              height: 28px;
              padding: 0 10px;
              border-radius: 4px;
              box-sizing: border-box;
              margin: 0 10px;
              border: 1px solid #dbdcdd;
            }
          }
          &:hover {
            color: #326afb;
          }
        }
        .active {
          padding: 5px 8px;
          background: #eceefe;
          border-radius: 12px;
          color: #326afb;
        }
      }
    }
  }
}
</style>
